module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-point-01-5347487f121b1d6d2ed68d89e43fcb74.jpg";